import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useResourceHints, type ResourceHint } from './hooks/useResourceHints';

// Cada ruta se carga bajo demanda para no enviar el JS de la sales page
// a quien solo abre el advertorial (y viceversa).
const Advertorial = lazy(() => import('./pages/Advertorial').then(m => ({
  default: m.Advertorial
})));
const SalesPage = lazy(() => import('./pages/SalesPage').then(m => ({
  default: m.SalesPage
})));
const RESOURCE_HINTS: ResourceHint[] = [{
  href: 'https://cdn.magicpatterns.com'
}, {
  href: 'https://fonts.googleapis.com'
}, {
  href: 'https://fonts.gstatic.com',
  crossOrigin: true
}];
interface AppProps {
  showStickyCta?: boolean;
  showReadingProgress?: boolean;
  showLiveActivity?: boolean;
}
export function App({
  showStickyCta = true,
  showReadingProgress = true,
  showLiveActivity = true
}: AppProps) {
  useResourceHints(RESOURCE_HINTS);
  return <BrowserRouter data-id="element-0" data-mp="3ijxpqrsp22kf">
      <Suspense fallback={<div className="min-h-screen w-full bg-ink" aria-busy="true" data-id="element-2" data-mp="3iiweonbohg2p" />} data-id="element-1" data-mp="3ikh829m9asyz">
        <Routes data-id="element-3" data-mp="3mlaxj7fckftz">
          <Route path="/" element={<Advertorial showStickyCta={showStickyCta} showReadingProgress={showReadingProgress} data-id="element-5" data-mp="3rc9em985thya" />} data-id="element-4" data-mp="3mkrchhuehbbq" />
          <Route path="/SPP" element={<SalesPage showStickyCta={showStickyCta} showLiveActivity={showLiveActivity} data-id="element-7" data-mp="7suzhf7pr6a" />} data-id="element-6" data-mp="6hovayao7c0" />
          <Route path="/spp" element={<Navigate to="/SPP" replace data-id="element-9" data-mp="33lx0ggmbmoz9" />} data-id="element-8" data-mp="33moqzd129wio" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-11" data-mp="38lrpsfqg76i7" />} data-id="element-10" data-mp="33oriy2lrxzq1" />
        </Routes>
      </Suspense>
    </BrowserRouter>;
}